import React, { useEffect, useState } from 'react'
import { set, useFieldArray } from 'react-hook-form'
import InputController from '../../Global/InputController'

const QuestionOptionsForm = ({
  surveyId,
  questionId,
  setValue,
  emptyText = 'Aún no hay opciones',
  prefix = 'prefix',
  control,
  idsToDeleteOptions,
  setIdsToDeleteOptions,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: prefix,
  })

  useEffect(() => {
    if (fields.length === 0) {
      append({ option_text: '', id: null })
    }

    if (surveyId) {
      fields.forEach((_, idx) => {
        if (typeof questionId === 'number') {
          setValue(`${prefix}[${idx}].question_id`, questionId)
        }
      })
    }
  }, [fields, surveyId, append, setValue, questionId])

  const handleRemove = (option, idx) => {
    if (surveyId && option.id) {
      setIdsToDeleteOptions((prev) => [...prev, option.id])
    }
    remove(idx)
  }

  const handleAdd = () => {
    append({ option_text: '', id: null })
  }

  return (
    <>
      {fields.length === 0 ? (
        <div className="col-12">
          <p>{emptyText}</p>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <h4>Opciones&nbsp;</h4>
            <span style={{ cursor: 'pointer' }} onClick={handleAdd}>
              <i className="fas fa-plus-circle fa-lg"></i>
            </span>
          </div>
          <div className="row">
            {fields.map((option, fieldIdx) => (
              <div
                key={option.id || `${prefix}-${fieldIdx}`}
                className="col-md-12 col-lg-3"
              >
                <span
                  onClick={() => handleRemove(option, fieldIdx)}
                  style={{ cursor: 'pointer', marginRight: '10px' }}
                >
                  <i className="fas fa-times"></i>
                </span>
                <div className="hide">
                  <InputController
                    type="text"
                    name={`${prefix}[${fieldIdx}].id`}
                    value={option.id || ''}
                    control={control}
                  />
                </div>
                <InputController
                  name={`${prefix}[${fieldIdx}].option_text`}
                  label={`Opción ${fieldIdx + 1}`}
                  placeholder="Ingresa el texto de la opción"
                  type="text"
                  control={control}
                />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default QuestionOptionsForm
